import { HostifyService } from "../_services/hostify.service";
import { HostifyStore } from "../_stores/HostifyStore";
import { genericActions } from "./generic.actions"

export const hostifyActions = {
    listListings,
    listListingsByApikey,
}

function listListings(integrationUID: string) {
    return async (dispatch) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const listings = await HostifyService.listListings(integrationUID);
            dispatch(HostifyStore.actionListItemsSuccess(listings));
        }
    }
}

// Fills the property picker from a typed-in apikey, with nothing persisted yet.
function listListingsByApikey(apikey: string) {
    return async (dispatch) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const listings = await HostifyService.listListingsByApikey(apikey);
            dispatch(HostifyStore.actionListItemsSuccess(listings));
        }
    }
}
